import { render, staticRenderFns } from "./DeleteConfirm.vue?vue&type=template&id=0fab94c4&scoped=true&"
import script from "./DeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirm.vue?vue&type=style&index=0&id=0fab94c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab94c4",
  null
  
)

export default component.exports